module.exports = __webpack_public_path__ + "img/fondation-mathieu-froment-savoie.46695adc.png";